import React, { useState } from 'react';
import { Col } from 'antd';
import { useMediaQuery } from 'react-responsive';

import { ModalAttendance } from '../../../../components/ModalAttendance';
import { CollapseCustom } from './Collapse';
import { useMatrizConsulta } from './context';

import * as S from './styles';

export function Formulario() {
  const screen = useMediaQuery({ query: '(min-width: 1200px)' });
  const {
    matriz,
    isEditMatriz,
    validarConsulta,
    validarMatriz,
    updateOpenForm,
    createNewMatriz,
    updateMatrizCadastro,
    updateMatriz,
    updateMatrizItemEdit,
  } = useMatrizConsulta();

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [titleModal, setTitleModal] = useState('');

  const saveMatriz = payload => isEditMatriz
      ? updateMatrizCadastro(payload)
      : createNewMatriz(payload);

  const toggleModal = () => {
    setTitleModal(
      'As alterações realizadas serão perdidas, deseja mesmo sair?'
    );
    setIsModalVisible(!isModalVisible);
  };

  const cancelModal = () => toggleModal();

  const okModal = () => {
    toggleModal();
    updateOpenForm(false);
    updateMatriz({});
    updateMatrizItemEdit({});
  };

  return (
    <S.Container additional height={screen}>
      <ModalAttendance
        title={titleModal}
        visible={isModalVisible}
        cancelBtn={cancelModal}
        okBtn={okModal}
      />
      <Col>
        <S.ContainerContent bordered={false}>
          <CollapseCustom />
        </S.ContainerContent>
      </Col>
      <Col>
        <S.ContainerBtn>
          <S.BottonCustom
            cancel
            bgcolor="#FFFFFF"
            onClick={toggleModal}
            margin
          >
            Cancelar
          </S.BottonCustom>
          <S.BottonCustom
            bgcolor={!validarMatriz || validarConsulta ? '#F2F2F2' : '#24A95D'}
            disabled={!validarMatriz || validarConsulta}
            onClick={() => saveMatriz(matriz)}
          >
            Salvar
          </S.BottonCustom>
        </S.ContainerBtn>
      </Col>
    </S.Container>
  );
}
